import { DeviceManifest } from '@rapoo/device-sdk'
import {
  mouseMacro,
  mousePerfCap,
  parametersLiftoffHigh,
  retailMouseConfig,
} from './generate/capabilityPresets'

/**
 * VT0 设备清单
 **/
const rapooVT0: DeviceManifest = {
  channel: ['china_game', 'global'],
  model: 'VT0',
  mainControl: 'VT0',
  dongleModel: 'Dongle_NordicL5',
  type: 'mouse',
  version: '1.0.0',
  hardware: {
    vendorId: 0x24ae,
    productId: [0x4610, 0x1410],
    currentPid: 0x4610,
    transport: 'HID',
    filters: [
      {
        usagePage: 65280,
        usage: 2,
        description: 'Configuration Interface (Secondary)',
        type: 'default',
      },
      {
        usagePage: 65280,
        usage: 14,
        description: 'Only update Firmware',
        type: 'update',
      },
      {
        usagePage: 65280,
        usage: 1,
        description: 'Only update WCH Firmware',
        type: 'updateWCH',
      },
    ],
  },
  driver: 'VT_nrf54L',
  MCU: 'N54L15',
  sensor: 'PAW3398',
  microSwitch: 'mechanical',
  encoder: 'mechanical',
  battery: 800,
  ui: {
    assetsDir: 'manifests/VT0',
    // 颜色配置
    colors: {
      series: [
        {
          name: 'common.products.VT0.Frozen_Blue',
          value: '#65A5C5',
          key: 'Frozen_Blue',
        },
        {
          name: 'common.products.VT0.White',
          value: '#F8FAFF',
          key: 'White',
        },
        {
          name: 'common.products.VT0.Black',
          value: '#2B2B2B',
          key: 'Black',
        },
      ],
      current: 'Frozen_Blue',
    },
    // 小图标
    icon: 'Hardware-Wireframe-Mouse',
    // 是否支持设备概览
    overview: true,
  },
  capabilities: [
    retailMouseConfig,
    parametersLiftoffHigh,
    {
      type: 'dpi',
      config: {
        min: 50,
        max: 26000,
        // 没有区间步进直接写步进值
        step: [{ from: 50, to: 26000, step: 50 }],
      },
    },
    mouseMacro,
    mousePerfCap({ tier: 'retail', sensorScanRateLabel: '10K', rfPacketType: 'wirelessOnly' }),
  ],
  layout: {
    keys: [
      [
        {
          key: 0,
          keywords: '左击',
          x: -25,
          y: 50,
          alignLeft: false,
          url: 'mouse left',
        },
        {
          key: 1,
          keywords: '中键',
          x: 240,
          y: 52,
          alignLeft: true,
          url: 'roller middle',
        },
        {
          key: 2,
          keywords: '右击',
          x: 240,
          y: 156,
          alignLeft: true,
          url: 'mouse right',
        },
        {
          key: 5,
          keywords: '右侧',
          x: -25,
          y: 132,
          alignLeft: false,
          url: 'mouse forward',
        },
        {
          key: 6,
          keywords: '左侧',
          x: -25,
          y: 195,
          alignLeft: false,
          url: 'mouse back',
        },
        {
          key: 9,
          keywords: '上滚',
          x: 240,
          y: 0,
          alignLeft: true,
          url: 'roller up',
        },
        {
          key: 10,
          keywords: '下滚',
          x: 240,
          y: 104,
          alignLeft: true,
          url: 'roller down',
        },
        {
          key: 13,
          keywords: 'DIY',
          x: 655,
          y: 118,
          alignLeft: true,
          url: 'diy',
        },
      ],
    ],
  },
}

export default rapooVT0
